import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
  ADD_AREA,
  DELETE_AREA,
  DELETE_CUSTOM_PLANT,
  GET_AREAS,
  UPDATE_AREA,
  GET_CUSTOM_PLANTS,
  SAVE_CUSTOM_PLANT,
  UPDATE_CUSTOM_PLANT,
  GET_OBJECTIVES,
  SAVE_OBJECTIVES,
  SEARCH_GUILD,
  GET_USER_GUILDS,
  CREATE_USER_GUILD,
  UPDATE_USER_GUILD,
  DELETE_USER_GUILD,
} from "./actionTypes"
import {
  getAreasSuccess,
  getAreasFail,
  addAreaFail,
  addAreaSuccess,
  updateAreaSuccess,
  updateAreaFail,
  fetchCustomPlantsSuccess,
  fetchCustomPlantsFail,
  updateCustomPlantSuccess,
  updateCustomPlantFail,
  saveCustomPlantSuccess,
  saveCustomPlantFail,
  deleteCustomPlantSuccess,
  deleteCustomPlantFail,
  deleteAreaSuccess,
  deleteAreaFail,
  getObjectivesSuccess,
  getObjectivesFail,
  saveObjectivesSuccess,
  saveObjectivesFail,
  searchGuildFail,
  searchGuildSuccess,
  getUserGuildsSuccess, getUserGuildsFail,
  createUserGuildSuccess, createUserGuildFail,
  updateUserGuildSuccess, updateUserGuildFail,
  deleteUserGuildSuccess, deleteUserGuildFail,
} from "./actions"

//Include Both Helper File with needed methods
import {
  getLoggedInUser,
  addArea,
  getAreas,
  fetchCustomPlants,
  updateArea,
  updateCustomPlant,
  postCustomPlant,
  deleteCustomPlant,
  deleteArea,
  getObjectives,
  saveObjectives,
  searchGuild,
  getUserGuilds,
  createUserGuild,
  updateUserGuild,
  deleteUserGuild,
} from "../../helpers/fakebackend_helper"

function* fetchAreas() {
  try {
    const user = getLoggedInUser()
    const response = yield call(getAreas, user)
    yield put(getAreasSuccess(response))
  } catch (error) {
    yield put(getAreasFail(error))
  }
}

function* onAddArea ({ payload: area}) {
  try {     
     const user = getLoggedInUser()
     area["username"] = user
     console.log(area)
     const response = yield call(addArea, area)
     yield put(addAreaSuccess(response))
  } catch (error) { 
     yield put(addAreaFail(error))
  }
}

function* onUpdateArea ({ payload: area}) {
  try {
     const response = yield call(updateArea, area)
     yield put(updateAreaSuccess(area))
  } catch (error) {
     yield put(updateAreaFail(error))
  }
}

function* onFetchCustomPlants() {
  try {
    const user = getLoggedInUser()
    const response = yield call(fetchCustomPlants, user)
    yield put(fetchCustomPlantsSuccess(response))
  } catch (error) {
    yield put(fetchCustomPlantsFail(error))
  }
}

function* onUpdateCustomPlant ({ payload: plant}) {
  try {
     const response = yield call(updateCustomPlant, plant)
     yield put(updateCustomPlantSuccess(plant))
  } catch (error) {
     yield put(updateCustomPlantFail(error))
  }
}

function* onSaveCustomPlant ({ payload: plant}) {
  try {
     yield call(postCustomPlant, plant)
     yield put(saveCustomPlantSuccess(plant))
  } catch (error) {
     yield put(saveCustomPlantFail(error))
  }
}

function* onSearchGuild ({ payload: searchGuildParams}) {
  try {
     console.log(searchGuildParams)
     const response = yield call(searchGuild, searchGuildParams)
     yield put(searchGuildSuccess(response))
  } catch (error) {
     yield put(searchGuildFail(error))
  }
}

function* onDeleteCustomPlant ({ payload: id}) {
  try {
     const response = yield call(deleteCustomPlant, id)
     yield put(deleteCustomPlantSuccess(id))
  } catch (error) {
     yield put(deleteCustomPlantFail(error))
  }
}

function* onDeleteArea ({ payload: id}) {
  try {
     const response = yield call(deleteArea, id)
      console.log(response);
     yield put(deleteAreaSuccess(id))
  } catch (error) {
     yield put(deleteAreaFail(error))
  }
}

function* fetchObjectives() {
  try {
    const user = getLoggedInUser()
    const response = yield call(getObjectives, user)
    yield put(getObjectivesSuccess(response))
  } catch (error) {
    yield put(getObjectivesFail(error))
  }
}

function* onSaveObjectives ({ payload: objectives}) {
  try {
     const response = yield call(saveObjectives, objectives)
     yield put(saveObjectivesSuccess(response))
  } catch (error) {
     yield put(saveObjectivesFail(error))
  }
}

const parseGuildResponse = (response) => {
  if (response && typeof response.body === 'string') return JSON.parse(response.body)
  if (response && response.body) return response.body
  return response
}

function* onGetUserGuilds() {
  try {
    const user = getLoggedInUser()
    const response = yield call(getUserGuilds, user)
    yield put(getUserGuildsSuccess(parseGuildResponse(response)))
  } catch (error) {
    yield put(getUserGuildsFail(error))
  }
}

function* onCreateUserGuild({ payload: guild }) {
  try {
    const user = getLoggedInUser()
    const response = yield call(createUserGuild, { ...guild, username: user })
    yield put(createUserGuildSuccess(parseGuildResponse(response)))
  } catch (error) {
    yield put(createUserGuildFail(error))
  }
}

function* onUpdateUserGuild({ payload: guild }) {
  try {
    const response = yield call(updateUserGuild, guild)
    yield put(updateUserGuildSuccess(parseGuildResponse(response)))
  } catch (error) {
    yield put(updateUserGuildFail(error))
  }
}

function* onDeleteUserGuild({ payload: id }) {
  try {
    yield call(deleteUserGuild, id)
    yield put(deleteUserGuildSuccess(id))
  } catch (error) {
    yield put(deleteUserGuildFail(error))
  }
}

function* goalsSaga() {
  yield takeEvery(GET_AREAS, fetchAreas)
  yield takeEvery(ADD_AREA, onAddArea)
  yield takeEvery(UPDATE_AREA, onUpdateArea)
  yield takeEvery(GET_CUSTOM_PLANTS, onFetchCustomPlants)
  yield takeEvery(UPDATE_CUSTOM_PLANT, onUpdateCustomPlant)
  yield takeEvery(SAVE_CUSTOM_PLANT, onSaveCustomPlant)
  yield takeEvery(DELETE_AREA, onDeleteArea)
  yield takeEvery(DELETE_CUSTOM_PLANT, onDeleteCustomPlant)
  yield takeEvery(GET_OBJECTIVES, fetchObjectives)
  yield takeEvery(SAVE_OBJECTIVES, onSaveObjectives)
  yield takeEvery(SEARCH_GUILD, onSearchGuild)
  yield takeEvery(GET_USER_GUILDS, onGetUserGuilds)
  yield takeEvery(CREATE_USER_GUILD, onCreateUserGuild)
  yield takeEvery(UPDATE_USER_GUILD, onUpdateUserGuild)
  yield takeEvery(DELETE_USER_GUILD, onDeleteUserGuild)
}

export default goalsSaga

